import { Component } from "../interface/component";

export class AnnouncementBar implements Component {

    private $root: JQuery;

    constructor(elem: HTMLElement) {
        this.$root = $(elem);
        this.init();
    }

    init() {
        $(document).on('click', '.c-announcement-bar--dismiss', (event) => {
            $(event.target).closest('.l-announcement-bar').addClass('hide');
        });
    }
}
